import { useQuery } from "@apollo/client";
import React, { useEffect, useState } from 'react'
import PhotoUploader from './PhotoUploader'
import PhotoList from './PhotoList';
import { Dialog} from '@material-ui/core';
import { mutateData } from '../Service/graphQlService';
import { GET_Events_Photos_QUERY } from '../Graphql/Symposium/symposiumQuery';
import { UPDATE_SYMPOSIUM_PHOTOS } from "../Graphql/Symposium/symposiumMutation";
import "./Symposium.scss"
import marked from "../../marked";


const Symposium = () => {
  const token = localStorage.getItem("authToken");
  const accessGrantedEmail  = ["jpierson@strivere.com","jgreen@strivere.com","crussell@strivere.com","lzeba@strivere.com"]
  const hasUploadAccess = uploadPhotoAccess();

function uploadPhotoAccess() {
  const data = sessionStorage.getItem("userData");

  if (!data) return false;

  let parsedData = {};
  try {
    parsedData = JSON.parse(data);
  } catch (e) {
    return false;
  }

  if (!parsedData.email) return false;

  return accessGrantedEmail.indexOf(parsedData.email.toLowerCase()) > -1;
}

const [eventData, setEventData] = useState(null);
const [eventTitle, setEventTitle] = useState("");
const [eventDate, setEventDate] = useState("");
const [eventDescription, setEventDescription] = useState("");

  const [showWebsite, setShowWebsite] = useState("y");
const [eventImages, setEventImages] = useState([]);

const [eventVideos, setEventVideos] = useState([]);
const [eventLinks, setEventLinks] = useState([]);

  const [errorMsg,setErrorMsg]= useState(false)
  const [isLoading,setIsLoading] = useState(false)
const [previewIndex, setPreviewIndex] = useState(null);
 const [isDialogOpen, setIsDialogOpen] = useState(false);
 const [isDeleted, setIsDeleted] = useState(false);
// const [originalPhotos, setOriginalPhotos] = useState([]);
const [symposiumOptions, setSymposiumOptions] = useState([]);

const symposiumYear = symposiumOptions.length > 0 ? symposiumOptions[0].year : null;
 const [selectedCategory, setSelectedCategory] = useState(null);
const [isEditMode,setEditMode] = useState(false)


function getEventPermission(type) {
  if (!eventApiData || !eventApiData.getEvents) return false;

  const currentYear = new Date().getFullYear();

  // Does current year event already exist?
  const currentYearEvent = eventApiData.getEvents.find(function (event) {
    return (
      event.date &&
      new Date(event.date).getFullYear() === currentYear
    );
  });

  // Selected year from dropdown
  const selectedYear =
    eventData && eventData.date
      ? new Date(eventData.date).getFullYear()
      : null;

  if (type === "add") {
    // Allow add only if current year event DOES NOT exist
    return !currentYearEvent;
  }

  if (type === "edit") {
    // Allow edit only if selected year is current year
    return selectedYear === currentYear;
  }

  return false;
}


const { data: eventApiData,refetch } = useQuery(
  GET_Events_Photos_QUERY,
  {
    variables: {}, // <-- empty initially (IMPORTANT)
    fetchPolicy: "no-cache",
    context: { headers: { authorization: `Bearer ${token}` } },
  }
);


const handleNext = () => {
  setPreviewIndex((prev) =>
    prev === eventImages.length - 1 ? 0 : prev + 1
  );
};

const handlePrev = () => {
  setPreviewIndex((prev) =>
    prev === 0 ? eventImages.length - 1 : prev - 1
  );
};


/* =========================================
   YOUTUBE EMBED CONVERTER
========================================= */

function convertToYouTubeEmbed(url) {
  if (!url) return null;

  var videoId = null;

  try {
    var parsedUrl = new URL(url);

    // youtube.com domain
    if (parsedUrl.hostname.indexOf("youtube.com") !== -1) {

      // watch?v=
      if (parsedUrl.searchParams.get("v")) {
        videoId = parsedUrl.searchParams.get("v");
      }

      // /embed/
      if (parsedUrl.pathname.indexOf("/embed/") !== -1) {
        videoId = parsedUrl.pathname.split("/embed/")[1];
      }

      // 🔥 /shorts/
      if (parsedUrl.pathname.indexOf("/shorts/") !== -1) {
        videoId = parsedUrl.pathname.split("/shorts/")[1];
      }
    }

    // youtu.be domain
    if (parsedUrl.hostname.indexOf("youtu.be") !== -1) {
      videoId = parsedUrl.pathname.replace("/", "");
    }

  } catch (e) {
    return null;
  }

  if (!videoId) return null;

  // Remove any extra query parameters after ID
  if (videoId.indexOf("?") !== -1) {
    videoId = videoId.split("?")[0];
  }

  return "https://www.youtube.com/embed/" + videoId;
}

/* =========================================
   PARSE EVENT CONTENT
   Supports:
   - Old markdown-based text
   - New photos[]
   - New videoLinks[]
   - description fallback
========================================= */

function parseEventContent(selectedEvent) {

  if (!selectedEvent) {
    setEventImages([]);
    setEventVideos([]);
    setEventLinks([]);
    setEventDescription("");
    return;
  }

  var images = [];
  var videos = [];
  var links = [];
  var cleanedText = "";

  /* =====================================
      HANDLE NEW STRUCTURE FIRST
  ===================================== */

if (selectedEvent.photos && selectedEvent.photos.length) {
  images = selectedEvent.photos
    .filter(function (photo) {
      return photo.status === "Active";   // only active photos
    })
    .map(function (photo) {
      return {
        id: photo.id,                     //  REAL BACKEND ID
        alt: photo.filename,
        url: photo.url || photo.s3_key || photo.path || ""
      };
    });
}


  if (selectedEvent.videoLinks && selectedEvent.videoLinks.length) {
videos = selectedEvent.videoLinks.map(function (video, index) {

  var embed = convertToYouTubeEmbed(video.url);

  return {
    id: "video-" + index,
    title: video.title || "Video",
    url: embed,
    originalUrl: video.url,
    isValid: embed ? true : false
  };

});
  }

  /* =====================================
      CONTENT PRIORITY
  ===================================== */

  var rawContent = "";

  if (
    selectedEvent.text &&
    selectedEvent.text.trim() !== ""
  ) {
    rawContent = selectedEvent.text;
  }
  else if (
    selectedEvent.description &&
    selectedEvent.description.trim() !== ""
  ) {
    rawContent = selectedEvent.description;
  }
  else {
    rawContent = "";
  }

  cleanedText = rawContent;

  /* =====================================
      LEGACY MARKDOWN PARSING
     (Only if rawContent exists)
  ===================================== */

  if (rawContent) {

    var parser = new DOMParser();
    var doc = parser.parseFromString(rawContent, "text/html");

    /* ---- Extract iframe videos ---- */

    var iframes = doc.querySelectorAll("iframe");

    iframes.forEach(function (iframe, index) {

      var src = iframe.getAttribute("src");

      if (src && src.indexOf("youtube") !== -1) {

        if (src.indexOf("?") !== -1) {
          src = src.split("?")[0];
        }

        videos.push({
          id: "iframe-" + Date.now() + index,
          title: "YouTube Video",
          url: src
        });
      }

      iframe.remove();
    });

    cleanedText = doc.body.innerHTML;

    /* ---- Extract markdown images ---- */

    var imageRegex = /!\[(.*?)\]\((.*?)\)/g;
    var match;

    while ((match = imageRegex.exec(cleanedText)) !== null) {

      images.push({
        id: "img-" + Date.now() + Math.random(),
        alt: match[1],
        url: match[2]
      });

    }

    cleanedText = cleanedText.replace(imageRegex, "");

    /* ---- Extract markdown links ---- */

    var fullLinkRegex = /\[(.*?)\]\((.*?)\)([^\n]*)/g;

    while ((match = fullLinkRegex.exec(cleanedText)) !== null) {

      var clickableText = match[1];
      var linkUrl = match[2];

      var embedUrl = convertToYouTubeEmbed(linkUrl);

      if (embedUrl) {

        videos.push({
          id: "video-" + Date.now() + Math.random(),
          title: clickableText,
          url: embedUrl
        });

      } else {

        links.push({
          id: "link-" + Date.now() + Math.random(),
          clickableText: clickableText,
          url: linkUrl,
          type: linkUrl.toLowerCase().indexOf(".pdf") !== -1
            ? "pdf"
            : "normal"
        });
      }
    }

    cleanedText = cleanedText.replace(fullLinkRegex, "");
  }

  /* =====================================
      CLEAN EXTRA MARKUP
  ===================================== */

  cleanedText = cleanedText
    .replace(/<\/?center>/g, "")
    .replace(/___/g, "")
    .replace(/####/g, "")
    .replace(/<br\s*\/?>/g, "")
    .trim();

  /* =====================================
      FINAL STATE
  ===================================== */

  setEventImages(images);
  setEventVideos(videos);
  setEventLinks(links);
  setEventDescription(cleanedText);
}



/* =========================================
   BUILD DROPDOWN OPTIONS (DATE BASED)
========================================= */

useEffect(function () {

  if (!eventApiData) return;
  if (!eventApiData.getEvents) return;

  var allEvents = eventApiData.getEvents;

  var currentYear = new Date().getFullYear();

  var options = allEvents
    .filter(function (item) {

      if (!item.date) return false;

      var eventDate = new Date(item.date);

      if (isNaN(eventDate.getTime())) return false;

      var eventYear = eventDate.getFullYear();

      // Show only current year and future events
      return eventYear >= currentYear;

    })
    .map(function (item) {

      return {
        label: item.title,
        value: item.arcimedes_row_id,
        date: item.date
      };

    })
    .sort(function (a, b) {

      return new Date(b.date) - new Date(a.date);

    });

  setSymposiumOptions(options);

  // Auto select newest event after refetch
  if (options.length > 0) {
    setSelectedCategory(options[0].value);
  }

}, [eventApiData]);



/* =========================================
    PARSE SELECTED EVENT
========================================= */

useEffect(function () {

  if (
    !eventApiData ||
    !eventApiData.getEvents ||
    !selectedCategory
  ) return;

  var allEvents = eventApiData.getEvents;

  var selectedEvent = allEvents.find(function (item) {
    return item.arcimedes_row_id === selectedCategory;
  });

  if (!selectedEvent) return;

  setEventData(selectedEvent);
  setEventTitle(selectedEvent.title || "");
  setEventDate(selectedEvent.date || "");

  /* 🔥 SET WEBSITE TOGGLE HERE (PARENT) */
  if (selectedEvent.showWebsite) {
    setShowWebsite(selectedEvent.showWebsite);
  } else {
    setShowWebsite("y");
  }

  // Parse content
  parseEventContent(selectedEvent);

}, [
  selectedCategory,
  eventApiData && eventApiData.getEvents
]);


const handleDelete = (photo) => {
  if (!photo || !photo.id) return;
  setEventData((prev) =>
    prev.map((p) =>
      String(p.id) === String(photo.id)
        ? { ...p, status: "Inactive" }
        : p
    )
  );
  setIsDeleted(true)
};



const handleEdit  = () => {
setEditMode(true)
setIsDialogOpen(true)
}

const handleAdd = () => {
  setEditMode(false)
setIsDialogOpen(true)
}


const arrowStyle = (side) => ({
  position: "absolute",
  top: "50%",
  [side]: "30px",
  transform: "translateY(-50%)",
  fontSize: "40px",
  color: "#7EB233",
  cursor: "pointer",
  userSelect: "none",
  fontWeight: "bold"
});


return (
  <div className="page-rounded-corner-container">

    {/* ================= HEADER ================= */}
    <div className="page-header-container list">
      <div className="page-header list">

        {/* ROW 1 : Title + Dropdown */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px 35px 0px",
            width: "100%"
          }}
        >
          <h2 style={{ margin: 0, color: "#7EB233" }}>
            Symposium
          </h2>

          {symposiumOptions && symposiumOptions.length > 0 && (
            <div style={{ marginLeft: "auto" }}>
              <select
                value={selectedCategory || ""}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                {symposiumOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

      </div>

      <div className="line" />
    </div>

    {/* ================= BODY ================= */}
    <div className="page-body-container crud">

      {hasUploadAccess && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px 35px 0px",   // same padding as dropdown row
            width: "100%"
          }}
        >
          {/* LEFT SIDE BUTTONS */}
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              className="button-new positive"
              style={{ width: "136px" }}
              onClick={handleAdd}
            >
              ADD EVENT
            </button>

            <button
              className="button-new positive"
              style={{ width: "136px" }}
              onClick={handleEdit}
            >
              EDIT
            </button>
          </div>
<div
  style={{
    marginLeft: "768px",
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  }}
>
    <div
    style={{
      width: "12px",
      height: "12px",
      borderRadius: "50%",
      backgroundColor: showWebsite === "y" ? "#7EB233" : "#ccc",
      boxShadow: "0 0 4px rgba(0,0,0,0.2)"
    }}
  />
  <span style={{ fontSize: "13px", color: "#666" }}>
    Website
  </span>


</div>
   
        </div>
      )}

      {hasUploadAccess && <div className="line" />}
             {/* RIGHT SIDE WEBSITE TOGGLE */}
         

      {/* ================= EVENT TITLE ================= */}
      {eventTitle && (
        <h3 className="event-title">
          {eventTitle}
        </h3>
      )}

      {/* ================= EVENT DESCRIPTION ================= */}
      {eventDescription && (
        <div
          className="event-description"
          dangerouslySetInnerHTML={{ __html: marked(eventDescription) }}
        />
      )}

      {/* ================= PHOTO UPLOADER ================= */}
      <PhotoUploader
        arcimedesRowId={eventData && eventData.arcimedes_row_id}
        eventData={eventData}
        eventTitle={eventTitle}
        setEventTitle={setEventTitle}
        eventDate={eventDate}
        setEventDate={setEventDate}
        eventDescription={eventDescription}
        setEventDescription={setEventDescription}
        eventImages={eventImages}
        setEventImages={setEventImages}
        eventVideos={eventVideos}
        setEventVideos={setEventVideos}
        eventLinks={eventLinks}
        setEventLinks={setEventLinks}
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        isEditMode={isEditMode}
        setIsLoading={setIsLoading}
        setErrorMsg={setErrorMsg}
        refetchPhotos={refetch}
        isLoading={isLoading}
        showWebsite={showWebsite}
        setShowWebsite={setShowWebsite}
      />

      {/* ================= PHOTO LIST ================= */}
      <PhotoList
        eventImages={eventImages}
        eventVideos={eventVideos}
        eventLinks={eventLinks}
        eventDescription={eventDescription}
        hasUploadAccess={hasUploadAccess}
        onPreview={setPreviewIndex}
        isLoading={isLoading}
        onAddClick={handleEdit}
      />

    </div>

    {/* ================= IMAGE PREVIEW DIALOG ================= */}
    <Dialog
      open={previewIndex !== null}
      onClose={() => setPreviewIndex(null)}
      maxWidth={false}
      fullWidth
      PaperProps={{
        style: {
          background: "transparent",
          boxShadow: "none"
        }
      }}
    >
      {previewIndex !== null && (
        <div
          style={{
            position: "relative",
            height: "100vh",
            background: "rgba(0,0,0,0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          {/* LEFT ARROW */}
          <div onClick={handlePrev} style={arrowStyle("left")}>
            ❮
          </div>

          {/* IMAGE */}
          <img
            src={eventImages[previewIndex].url}
            alt=""
            style={{
              maxWidth: "90%",
              maxHeight: "90vh",
              borderRadius: "8px"
            }}
          />

          {/* RIGHT ARROW */}
          <div onClick={handleNext} style={arrowStyle("right")}>
            ❯
          </div>
        </div>
      )}
    </Dialog>

  </div>
);
}

export default Symposium
